const template = `
   
`;

export default window.Handlebars.compile(template);
